var decorators = {};

export { decorators as __exports };
